import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { ExcelService } from '../../../../services/infrastructure/excel.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { CppReportService } from './../../../../services/cpp/cpp-report.service';
import { ColumnDescription, UserReportFilter } from '../../../../models/user-report-filter.model';
import { UserReportFilterSliderService } from '../../../../common/components/user-report-filter/user-report-filter-slider.service';
import { ToastrService } from 'ngx-toastr';
import { UserReportFilterService } from '../../../../services/seed/reports/user-report-filter.service';
import { UserFilterColumnDisplayed } from '../../../../models/user-filter-columndisplayed.model';
import { ReportType } from '../../../../models/report-type.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cpp-sulfur-zinc-pricing',
  templateUrl: './cpp-sulfur-zinc-pricing.component.html',
  styleUrls: ['./cpp-sulfur-zinc-pricing.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CppSulfurZincPricingComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();

  truckLoadsizeData: any = [];
  productTypeData: any = [];
  stateData: any = [];
  searchTruckLoadSize = '';
  searchproductType = '';
  searchstate = '';
  SulfurZincPricingdList: any = [];
  FilteredData: any = [];
  createTimestamp: any;
  UpdateTimestamp: any;
  ItemNumberFilter = new UntypedFormControl();
  ItemDescriptionFilter = new UntypedFormControl();

  public SulfurZincPricingdListDataSource: MatTableDataSource<any>;
  fixedColumn: string[] = ['stateDescription', 'truckLoadSize', 'productType'];
  private readonly originalDisplayedColumns: Array<ColumnDescription> = [
    { columnfield: 'stateDescription', headertxt: 'State' },
    { columnfield: 'truckLoadSize', headertxt: 'Truck Load Size' },
    { columnfield: 'productType', headertxt: 'Product Type' },
    { columnfield: 'itemNumber', headertxt: 'Item Number' },
    { columnfield: 'itemDesc', headertxt: 'Item Description' },
    { columnfield: 'itemDesc2', headertxt: 'Package Size' },
    { columnfield: 'price', headertxt: 'Price' }
  ];
  public currentFilter = new UserReportFilter();

  filterValueList = new Array();
  displayedColumns: string[] = this.originalDisplayedColumns.map(x => x.columnfield);

  filteredValues = {
    itemNumber: '',
    itemDesc: '',
    productType: null,
    truckLoadSize: null,
    stateDescription: null,
  };

  constructor(private CppReportService: CppReportService,
    private loaderService: LoaderService,
    private excelService: ExcelService,
    private toastrService: ToastrService,
    private userReportFilterSliderService: UserReportFilterSliderService,
    private userReportFilterService: UserReportFilterService,
    private router: Router) {
  }

  ngOnInit() {
    this.subscription.push(
      this.userReportFilterSliderService.selectedUserFilter.subscribe(filter => {
        if (filter && filter.reportFilter) {
          const filters: UserFilterColumnDisplayed = JSON.parse(filter.reportFilter);
          if (filter.reportTypeId === ReportType.SulfurAndZincReport) {
            this.currentFilter = filter;
            this.displayedColumns = [];
            this.displayedColumns.push('stateDescription', 'truckLoadSize', 'productType'); //Fixed column for Grid
            filters.displayedColumns.forEach(x => {
              this.displayedColumns.push(x.columnfield);
            });
            this.filteredValues = filters.filterOption;
            this.searchproductType = this.filteredValues['productType'] == null ? [] : this.filteredValues['productType'];
            this.searchstate = this.filteredValues['stateDescription'] == null ? [] : this.filteredValues['stateDescription'];
            this.searchTruckLoadSize = this.filteredValues['truckLoadSize'] == null ? [] : this.filteredValues['truckLoadSize'];
            this.filterRecords()
            this.SulfurZincPricingdListDataSource.filter = JSON.stringify(this.filteredValues);
          }
          else {
            this.currentFilter = new UserReportFilter();
          }
        }
        else {
          if ((filter && filter.reportTypeId === ReportType.SulfurAndZincReport
            && filter.filterDescription === this.currentFilter.filterDescription)
            || !filter) {
            this.displayedColumns = this.originalDisplayedColumns.map(x => x.columnfield);
            this.currentFilter = new UserReportFilter();
            this.filteredValues = {
              itemNumber: '',
              itemDesc: '',
              productType: null,
              truckLoadSize: null,
              stateDescription: null,
            };
            this.searchTruckLoadSize = '';
            this.searchstate = '';
            this.searchproductType = '';
            this.filterRecords();
          }
        }
      }));
    this.getSulfurZincPricing();
  }

  customFilterPredicate() {
    const myFilterPredicate = function (data: CppSulfurZincPricingElement, filter: string): boolean {
      const searchString = JSON.parse(filter);
      const itemNumberFound = data.itemNumber == null || data.itemNumber.toString().trim().toLowerCase().indexOf(searchString.itemNumber.toLowerCase()) !== -1;
      const itemDescriptionFound = data.itemDesc == null || data.itemDesc.toString().trim().toLowerCase().indexOf(searchString.itemDesc.toLowerCase()) !== -1;
      return itemNumberFound && itemDescriptionFound;
    };
    return myFilterPredicate;
  }

  // Get Cpp orders list
  getSulfurZincPricing() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.CppReportService.getSulfurZincPricingReportData().subscribe(result => {
      this.SulfurZincPricingdList = result.result;
      this.truckLoadsizeData = result.truckLoadSizeDistinct.filter((thing, i, arr) => arr.findIndex(x => x.truckLoadSize === thing.truckLoadSize && x.truckLoadSize != null) === i);
      this.productTypeData = result.productTypeDistinct.filter((thing, i, arr) => arr.findIndex(x => x.productType === thing.productType && x.productType != null) === i);
      this.stateData = result.stateDistinct.filter((thing, i, arr) => arr.findIndex(x => x.stateDescription === thing.stateDescription && x.stateDescription != null) === i);
      this.createTimestamp = result.createTimestamp[0].replace('T', ' ');
      this.UpdateTimestamp = result.updateTimestamp[0].replace('T', ' ');
      this.FilteredData = this.SulfurZincPricingdList;
      this.SulfurZincPricingdListDataSource = new MatTableDataSource(this.SulfurZincPricingdList);
      this.SulfurZincPricingdListDataSource.filterPredicate = this.customFilterPredicate();
      this.selectAllForDropdownItemsFortruckLoadsize(this.truckLoadsizeData);
      this.selectAllForDropdownItemsForProductType(this.productTypeData);
      this.selectAllForDropdownItemsForState(this.stateData);
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // Filter the records on basis of account number
  filterRecords() {
    if (this.searchproductType.length > 0 && this.searchTruckLoadSize.length > 0 && this.searchstate.length > 0) {
      let filteredproductTypeList: any = [];
      filteredproductTypeList = this.SulfurZincPricingdList.filter(x => { for (const filter of this.searchproductType) { if (x.productType == filter) { return true; } } });
      let filteredTruckSizeList: any = [];
      filteredTruckSizeList = filteredproductTypeList.filter(x => { for (const filter of this.searchTruckLoadSize) { if (x.truckLoadSize == filter) { return true; } } });
      const filteredStateList = filteredTruckSizeList.filter(x => { for (const filter of this.searchstate) { if (x.stateDescription == filter) { return true; } } });
      this.SulfurZincPricingdListDataSource = new MatTableDataSource(filteredStateList);
      this.FilteredData = filteredStateList;
    }
    else if (this.searchproductType.length > 0 && this.searchTruckLoadSize.length == 0 && this.searchstate.length > 0) {
      let filteredproductTypeList: any = [];
      filteredproductTypeList = this.SulfurZincPricingdList.filter(x => { for (const filter of this.searchproductType) { if (x.productType == filter) { return true; } } });
      const filteredStateList = filteredproductTypeList.filter(x => { for (const filter of this.searchstate) { if (x.stateDescription == filter) { return true; } } });
      this.SulfurZincPricingdListDataSource = new MatTableDataSource(filteredStateList);
      this.FilteredData = filteredStateList;
    }
    else if (this.searchproductType.length > 0 && this.searchTruckLoadSize.length > 0 && this.searchstate.length == 0) {
      let filteredproductTypeList: any = [];
      filteredproductTypeList = this.SulfurZincPricingdList.filter(x => { for (const filter of this.searchproductType) { if (x.productType == filter) { return true; } } });
      let filteredTruckSizeList: any = [];
      filteredTruckSizeList = filteredproductTypeList.filter(x => { for (const filter of this.searchTruckLoadSize) { if (x.truckLoadSize == filter) { return true; } } });
      this.SulfurZincPricingdListDataSource = new MatTableDataSource(filteredTruckSizeList);
      this.FilteredData = filteredTruckSizeList;
    }
    else if (this.searchproductType.length > 0 && this.searchTruckLoadSize.length == 0 && this.searchstate.length == 0) {
      let filteredproductTypeList: any = [];
      filteredproductTypeList = this.SulfurZincPricingdList.filter(x => { for (const filter of this.searchproductType) { if (x.productType == filter) { return true; } } });
      this.SulfurZincPricingdListDataSource = new MatTableDataSource(filteredproductTypeList);
      this.FilteredData = filteredproductTypeList;
    }
    else if (this.searchproductType.length == 0 && this.searchTruckLoadSize.length > 0 && this.searchstate.length == 0) {
      let filteredTruckSizeList: any = [];
      filteredTruckSizeList = this.SulfurZincPricingdList.filter(x => { for (const filter of this.searchTruckLoadSize) { if (x.truckLoadSize == filter) { return true; } } });
      this.SulfurZincPricingdListDataSource = new MatTableDataSource(filteredTruckSizeList);
      this.FilteredData = filteredTruckSizeList;
    }
    else if (this.searchproductType.length == 0 && this.searchTruckLoadSize.length > 0 && this.searchstate.length > 0) {
      let filteredTruckSizeList: any = [];
      filteredTruckSizeList = this.SulfurZincPricingdList.filter(x => { for (const filter of this.searchTruckLoadSize) { if (x.truckLoadSize == filter) { return true; } } });
      const filteredStateList = filteredTruckSizeList.filter(x => { for (const filter of this.searchstate) { if (x.stateDescription == filter) { return true; } } });
      this.SulfurZincPricingdListDataSource = new MatTableDataSource(filteredStateList);
      this.FilteredData = filteredStateList;
    }
    else if (this.searchproductType.length == 0 && this.searchTruckLoadSize.length == 0 && this.searchstate.length > 0) {
      let filteredStateList: any = [];
      filteredStateList = this.SulfurZincPricingdList.filter(x => { for (const filter of this.searchstate) { if (x.stateDescription == filter) { return true; } } });
      this.SulfurZincPricingdListDataSource = new MatTableDataSource(filteredStateList);
      this.FilteredData = filteredStateList;
    }
    else {
      this.SulfurZincPricingdListDataSource = new MatTableDataSource(this.SulfurZincPricingdList);
      this.FilteredData = this.SulfurZincPricingdList;
    }

    this.filteredValues['productType'] = this.searchproductType;
    this.filteredValues['truckLoadSize'] = this.searchTruckLoadSize;
    this.filteredValues['stateDescription'] = this.searchstate;

    this.SulfurZincPricingdListDataSource.filterPredicate = this.customFilterPredicate();
  }

  // Export data from grid data
  onExportBtnClick() {
    this.loaderService.setLoaderStatus(true);

    if (this.FilteredData && this.FilteredData.length > 0) {
      const excelData = [];
      if (this.filteredValues.itemDesc == '' && this.filteredValues.itemNumber == '') {
        this.FilteredData.forEach(x => {
          excelData.push(this.setHeaderForExport(x));
        });
      } else {
        this.FilteredData.forEach(x => {
          if ((this.filteredValues.itemNumber != '' && x.itemNumber.indexOf(this.filteredValues.itemNumber) > -1)
            && (this.filteredValues.itemDesc != '' && x.itemDesc.indexOf(this.filteredValues.itemDesc) > -1)) {
            excelData.push(this.setHeaderForExport(x));
          }
          else if (this.filteredValues.itemNumber == '' && this.filteredValues.itemDesc != '' && x.itemDesc.indexOf(this.filteredValues.itemDesc) > -1) {
            excelData.push(this.setHeaderForExport(x));
          }
          else if (this.filteredValues.itemDesc == '' && this.filteredValues.itemNumber != '' && x.itemNumber.indexOf(this.filteredValues.itemNumber) > -1) {
            excelData.push(this.setHeaderForExport(x));
          }
        });
      }

      setTimeout(x => {
        this.excelService.exportExcel(excelData, 'SulfurZincPricingList');
        this.loaderService.setLoaderStatus(false);
      }, 100);
    }
  }

  setHeaderForExport(data: any) {
    let exportDisplayedColumns = this.originalDisplayedColumns.filter(x => this.displayedColumns.find(y => x.columnfield == y));
    const exportData = new Map();
    exportDisplayedColumns.forEach(col => {
      switch (col.columnfield) {
        case 'stateDescription':
          exportData.set(col.headertxt, data.stateDescription)
          break;
        case 'truckLoadSize':
          exportData.set(col.headertxt, data.truckLoadSize)
          break;
        case 'productType':
          exportData.set(col.headertxt, data.productType)
          break;
        case 'itemNumber':
          exportData.set(col.headertxt, data.itemNumber)
          break;
        case 'itemDesc':
          exportData.set(col.headertxt, data.itemDesc)
          break;
        case 'itemDesc2':
          exportData.set(col.headertxt, data.itemDesc2)
          break;
        case 'price':
          exportData.set(col.headertxt, data.price)
          break;
        default: {
          break;
        }
      }
    });

    const obj = this.autoConvertMapToObject(exportData);

    return obj;
  }

  private autoConvertMapToObject = (map) => {
    const obj = {};
    for (const item of [...map]) {
      const [
        key,
        value
      ] = item;
      obj[key] = value;
    }
    return obj;
  }

  selectAllForDropdownItemsForState(items: any[]) {
    const allSelect = (items) => {
      items.forEach((element) => {
        element['selectedAllGroupbranchState'] = 'selectedAllGroupbranchState';
      });
    };

    allSelect(items);
  }

  selectAllForDropdownItemsFortruckLoadsize(items: any[]) {
    const allSelect = (items) => {
      items.forEach((element) => {
        element['selectedAllGroupTruckLoadSize'] = 'selectedAllGroupTruckLoadSize';
      });
    };

    allSelect(items);
  }

  selectAllForDropdownItemsForProductType(items: any[]) {
    const allSelect = (items) => {
      items.forEach((element) => {
        element['selectedAllGroupProductType'] = 'selectedAllGroupProductType';
      });
    };

    allSelect(items);
  }

  ddlOptionsSearchState = (term: string, item: any) => {
    term = term.toLocaleLowerCase();
    return item['stateDescription'].toLocaleLowerCase().indexOf(term) > -1;
  };

  ddlOptionsSearchTruckLoadSize = (term: string, item: any) => {
    term = term.toLocaleLowerCase();
    return item['truckLoadSize'].toLocaleLowerCase().indexOf(term) > -1;
  };

  ddlOptionsSearchProductType = (term: string, item: any) => {
    term = term.toLocaleLowerCase();
    return item['productType'].toLocaleLowerCase().indexOf(term) > -1;
  };

  //Select filter
  public selectFilter() {
    this.setFilter();
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filteredValues,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);
    var columns = this.originalDisplayedColumns.filter(item => !this.fixedColumn.includes(item.columnfield)).map(x => new ColumnDescription(x.columnfield, x.headertxt));

    this.userReportFilterSliderService.activeSlider(ReportType.SulfurAndZincReport, 0, columns, newFilter);
  }

  //Add filter
  public addFilter() {
    this.setFilter();
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filteredValues,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();
    var columns = this.originalDisplayedColumns.filter(item => !this.fixedColumn.includes(item.columnfield)).map(x => new ColumnDescription(x.columnfield, x.headertxt));
    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.SulfurAndZincReport, 1, columns, newFilter);
  }

  public editFilter() {
    this.setFilter();
    var column = this.originalDisplayedColumns.filter(item => !this.fixedColumn.includes(item.columnfield)).map(x => new ColumnDescription(x.columnfield, x.headertxt));
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filteredValues,
      filterValueList: this.filterValueList,
      displayedColumns: this.displayedColumns.filter(item => !this.fixedColumn.includes(item)).map(x => this.originalDisplayedColumns.find(y => y.columnfield === x))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.SulfurAndZincReport, 1, column, this.currentFilter);
  }

  public save(): void {
    this.setFilter();
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filteredValues,
      filterValueList: this.filterValueList,
      displayedColumns: this.displayedColumns.filter(item => !this.fixedColumn.includes(item)).map(x => this.originalDisplayedColumns.find(y => y.columnfield === x))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    if (this.currentFilter.userReportFilterId) {
      this.userReportFilterService.updateUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      });
    }
    else {
      this.userReportFilterService.addUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.currentFilter.userReportFilterId = filter.userReportFilterId;
          this.toastrService.success("Records saved successfully.");
        }
      });
    }
  }

  setFilter() {
    this.filterValueList = [];
    if (this.filteredValues.productType && this.filteredValues.productType != '') {
      this.filterValueList.push('Product Type : ' + this.filteredValues.productType.join());
    }
    if (this.filteredValues.truckLoadSize && this.filteredValues.truckLoadSize != '') {
      this.filterValueList.push('Truck Load Size : ' + this.filteredValues.truckLoadSize.join());
    }
    if (this.filteredValues.stateDescription && this.filteredValues.stateDescription != '') {
      this.filterValueList.push('State : ' + this.filteredValues.stateDescription.join());
    }
    if (this.filteredValues.itemNumber && this.filteredValues.itemNumber != '') {
      this.filterValueList.push('Item Number : ' + this.filteredValues.itemNumber);
    }
    if (this.filteredValues.itemDesc && this.filteredValues.itemDesc != '') {
      this.filterValueList.push('Item Description : ' + this.filteredValues.itemDesc);
    }
  }

  handleKeyevent(event) {
    if (event.keyCode == 13) {
      return false;
    }
  }

  filterByItemNumber(event) {
    this.filteredValues['itemNumber'] = event;
    this.SulfurZincPricingdListDataSource.filter = JSON.stringify(this.filteredValues);
  }

  filterByItemDesc(event) {
    this.filteredValues['itemDesc'] = event;
    this.SulfurZincPricingdListDataSource.filter = JSON.stringify(this.filteredValues);
  }

  redirectToSubscription() {
    this.router.navigate(['/cpp/report/sulfur-zinc-pricing-manage-subscription']);
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
    this.userReportFilterSliderService.resetFilter();
  }
}

export interface CppSulfurZincPricingElement {
  itemNumber: string;
  itemDesc: string;
}
